import { gql, useQuery } from "@apollo/client";
import { useEffect } from "react";

import { FullStoryAPI } from "@zapier/react-fullstory";

import { useAccountAndUser } from "@zapier/reporting/src/hooks/useAccountAndUser";
import { FlagsQuery } from "./useFlags.generated";

export const flagsQuery = gql`
  query Flags(
    $customuserId: ID!
    $isStaff: Boolean
    $planType: String
    $rolloutStage: String
  ) {
    flags(
      customuserId: $customuserId
      isStaff: $isStaff
      planType: $planType
      rolloutStage: $rolloutStage
    ) {
      monitor_account_audit_log
      monitor_ai_error_message
      monitor_held_runs_resolution
      monitor_unified_history_filter
      monitor_zaps_with_errors
      observe_alerts_contextual_drawer
      observe_alerts_mvp
      observe_analytics_error_rate_report
      observe_run_details_error_alert
      observe_run_history_v2
      team_observe_alert_rules_api
      use_new_exporter_zap_runs
      zap_run_request_logs
      alerts_admin_access_all
      editor_redirect_to_zap_runs
      editor_run_replays_improvements
      insights_alerts_high_task_usage
      editor_bulk_zap_import
      governance_inbox_release
    }
  }
`;

export function useFlags() {
  const { accountId, userId, isStaff, plan, limits } = useAccountAndUser();
  const { data, loading } = useQuery<FlagsQuery>(flagsQuery, {
    skip: !accountId || !userId,
    variables: {
      customuserId: userId,
      isStaff: isStaff,
      planType: plan?.planType ?? "",
      rolloutStage: limits?.rolloutStage ?? "",
    },
  });
  const flags = data?.flags;

  useEffect(() => {
    if (!loading && flags) {
      // @ts-ignore
      FullStoryAPI("setUserVars", flags);
    }
  }, [loading, flags]);

  return {
    accountId,
    flags,
    isFlagsLoading: loading,
  };
}
